import _concat from "lodash/concat";
import _get from "lodash/get";
import { AnyAction } from "redux";
import { DELIVERY_TYPE } from "../../../../../constants";
import { DeliveryInfoState } from "../../../../../models/state";
import { fulfilled } from "../../utils";
import * as AT from "../actionTypes";

const initialState: DeliveryInfoState = {
    methods: [],
    selected: {},
    deliveryAddress: {
        street: "",
        postcode: "",
        city: "",
    },
    note: "",
    onboardingMobileSupport: {
        selectedSku: "",
        info: {
            heading: "",
            ingress: "",
            services: [],
        },
    },
};

const updateProgressBarPlaceholderInfo = (state: DeliveryInfoState, action: AnyAction): DeliveryInfoState => {
    const shouldShowProgressBar = _get(action, "payload.cart.deliveryOption.type") === DELIVERY_TYPE.PROGRESS_BAR;
    const isShowingProgressBar = _get(state, "selected.type") === DELIVERY_TYPE.PROGRESS_BAR;

    if (!isShowingProgressBar && !shouldShowProgressBar) {
        return state;
    }

    if (shouldShowProgressBar && !isShowingProgressBar) {
        return {
            ...state,
            methods: _concat(state.methods, [action.payload.cart.deliveryOption]),
            selected: {
                type: DELIVERY_TYPE.PROGRESS_BAR,
            },
        };
    }

    if (!shouldShowProgressBar) {
        return {
            ...state,
            methods: (state.methods || []).filter((method) => method.type !== DELIVERY_TYPE.PROGRESS_BAR),
            selected: {},
        };
    }

    return state;
};

const reducer = (state = initialState, action: AnyAction): DeliveryInfoState => {
    switch (action.type) {
        case fulfilled(AT.CHECKOUT_SET_DELIVERY_TYPE):
            return {
                ...state,
                selected: {
                    ...state.selected,
                    type: action.payload.deliveryType,
                    code: action.payload.code,
                },
            };
        case fulfilled(AT.CHECKOUT_UPDATE_DELIVERY_ADDRESS):
            return {
                ...state,
                deliveryAddress: _get(action, "payload.updatedAddress", {}),
                methods: _get(action, "payload.delivery.methods", []),
                selected: _get(action, "payload.delivery.selected", null),
            };
        case AT.CHECKOUT_SET_DELIVERY_NOTE:
            return {
                ...state,
                note: action.note,
            };
        case AT.CHECKOUT_SET_DELIVERY_ZIPCODE:
            return {
                ...state,
                selected: {
                    ...state.selected,
                    zipCode: action.zipCode,
                },
            };
        case fulfilled(AT.CHECKOUT_FETCH_DELIVERY_AND_PAYMENT_METHODS):
            return {
                ...state,
                methods: _get(action, "payload.delivery.methods", []),
                selected: _get(action, "payload.delivery.selected", null),
                onboardingMobileSupport: _get(action, "payload.onboardingSupport", null),
            };
        case fulfilled(AT.CHECKOUT_ADD_ACCESSORY_TO_CART):
            return updateProgressBarPlaceholderInfo(state, action);
        default:
            return state;
    }
};

export default reducer;
